import React, { useEffect, useState } from 'react';
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';
import NoPictureWarning from "../../resources/nopic.png";
import axios from 'axios';
import ClientService from "../../rest/clientService"; 

const SmartImage = ({ src, alt, className, isThumb = true, type = 'product' }) => {
    const [imageBlob, setImageBlob] = useState(null);
    const [loaded, setLoaded] = useState(false);
    const [error, setError] = useState(false);
    const [isEnabled, setIsEnabled] = useState(null);

    useEffect(() => {
        let isMounted = true;

        const checkPreferenceAndFetch = async () => {
            try {
                const prefs = await ClientService.getClientAdminPreferences();
                
                const shouldShow = type === 'product' 
                    ? prefs?.enable_product_images 
                    : prefs?.enable_profile_pictures;

                if (!shouldShow) {
                    if (isMounted) {
                        setIsEnabled(false);
                        setLoaded(true);
                    }
                    return;
                }

                if (isMounted) setIsEnabled(true);

                const token = sessionStorage.getItem("authToken");
                const url = `${src}${src.includes('?') ? '&' : '?'}thumb=${isThumb}`;

                const response = await axios.get(url, {
                    responseType: 'blob',
                    headers: { 'Authorization': token ? `Bearer ${token}` : '' }
                });

                if (isMounted) {
                    const blobUrl = URL.createObjectURL(response.data);
                    setImageBlob(blobUrl);
                    setLoaded(true);
                }
            } catch (err) {
                console.error("Erro no SmartImage:", err);
                if (isMounted) {
                    setError(true);
                    setLoaded(true);
                }
            }
        };

        if (src) checkPreferenceAndFetch();

        return () => {
            isMounted = false;
            if (imageBlob) URL.revokeObjectURL(imageBlob);
        };
    }, [src, isThumb, type]);

    if (isEnabled === false) {
        return <img src={NoPictureWarning} className={`${className} opacity-40 object-contain p-8`} alt="Disabled" />;
    }

    return (
        <div className="relative w-full h-full overflow-hidden">
            {!loaded && (
                <div className="absolute inset-0">
                    <Skeleton height="100%" width="100%" borderRadius={0} />
                </div>
            )}

            <img
                src={error ? NoPictureWarning : imageBlob || ''}
                alt={alt}
                className={`w-full h-full transition-opacity duration-500 ${className} ${loaded ? "opacity-100" : "opacity-0"}`}
                style={{ visibility: loaded ? 'visible' : 'hidden', position: 'absolute', top: 0, left: 0 }}
            />
        </div>
    );
};

export default SmartImage;